import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import TimesheetEntrySpitForm from './components/TimesheetEntrySpitForm';

interface OwnProps {
    insertRows: Function;
}

interface ConnectedProps {
    open: boolean;
    id?: string;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class TimesheetEntrySpitModal extends React.PureComponent<Props> {
    handleClose = () => {
        this.props.updateQueryString({
            timesheetEntrySplitModal: undefined,
            selectedTimesheetEntry: undefined
        });
    };

    render(): React.ReactElement {
        const { open, id, insertRows } = this.props;
        return (
            <Modal
                size="fullscreen"
                open={open}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetEntrySpitModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Split Timesheet Entry</Modal.Header>
                    <Modal.Content className="constrain-width">
                        <TimesheetEntrySpitForm
                            timesheetEntryUuid={id}
                            onClose={this.handleClose}
                            insertRows={insertRows}
                        />
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    open: makeSelectQueryStringBooleanValue('timesheetEntrySplitModal'),
    id: makeSelectQueryStringValue('selectedTimesheetEntry')
});

export default connect(mapStateToProps, { updateQueryString })(
    TimesheetEntrySpitModal
);
